import { FlowStatus } from '@/features/crosschain-buy/domain/flow'
import type { CrosschainBuyViewState } from '@/features/crosschain-buy/buy-flow/view-state'

const SWAP_IN_PROGRESS_STATUSES = new Set<string>([
  FlowStatus.BRIDGE_APPROVING,
  FlowStatus.BRIDGE_SWAPPING,
  FlowStatus.BRIDGE_TRACKING,
  FlowStatus.SOLANA_JUPITER_SWAPPING,
  FlowStatus.SOLANA_LAYERSWAP_BRIDGING,
  FlowStatus.INTERMEDIATE_SYMBIOSIS_APPROVING,
  FlowStatus.INTERMEDIATE_SYMBIOSIS_SWAPPING,
  FlowStatus.INTERMEDIATE_SYMBIOSIS_TRACKING,
  FlowStatus.DESTINATION_SWAP_READY,
  FlowStatus.DESTINATION_SWAPPING,
  FlowStatus.SUCCESS,
  FlowStatus.ERROR,
])

export const START_NEW_SWAP_WARNING =
  'A transaction may still complete. Cancel this swap and stop the remaining steps?'

export const shouldConfirmStartingNewSwap = (state: CrosschainBuyViewState): boolean => {
  const hasIrreversibleBridge = state.steps.some(
    (step) =>
      (step.type === 'bridge' || step.type === 'jupiter_swap') &&
      (step.status === 'completed' || !!step.txHash)
  )
  const hasAmbiguousEvmBridge = Boolean(state.evmBridgeCheckpoint)
  return state.status !== FlowStatus.SUCCESS && (hasIrreversibleBridge || hasAmbiguousEvmBridge)
}

export const isFullyCompletedExecution = (state: CrosschainBuyViewState): boolean =>
  state.status === FlowStatus.SUCCESS &&
  state.steps.length > 0 &&
  state.steps.every((step) => step.status === 'completed')

export const shouldShowStartNewSwap = (state: CrosschainBuyViewState): boolean =>
  (SWAP_IN_PROGRESS_STATUSES.has(state.status) ||
    Boolean(state.evmApprovalCheckpoint) ||
    Boolean(state.evmBridgeCheckpoint)) &&
  !isFullyCompletedExecution(state)
